import './projections.js';
import { fromLonLat } from 'ol/proj';
import { Control } from 'ol/control';

export class AutourDeMoiControl extends Control {
  /**
   * @param {Object} [opt_options] Control options.
   */
  constructor(opt_options) {
    const options = opt_options || {};

    const button = document.createElement('button');
    // On utilise un background-image
    button.innerHTML = '&nbsp;';
    button.title = 'Centrer autour de moi';

    const element = document.createElement('div');
    element.className = 'ol-autour-de-moi ol-unselectable ol-control';
    element.appendChild(button);

    super({
      element: element,
      target: options.target,
    });

    button.addEventListener('click', this.trackPosition.bind(this), false);
  }

  trackPosition() {
    if (!navigator.geolocation) {
      return;
    }
    const that = this;
    navigator.geolocation.getCurrentPosition(function (position) {
      const geoloc = [position.coords.longitude, position.coords.latitude];
      const coords = fromLonLat(
        geoloc,
        that.getMap().getView().getProjection(),
      );
      that.getMap().getView().setCenter(coords);
      that.getMap().getView().setZoom(5);
    });
  }
}
